import { env } from './env'

export const TOKEN_STORAGE_KEY = '@Conexa:token'

export const USER_STORAGE_KEY = '@Conexa:user'

export const INITIAL_QUERY_PARAMS = {
  page: 1,
  itemsPerPage: 10,
}

export const INITIAL_DATA_RESULTS = {
  page: 1,
  length: 0,
  pageQuantity: 0,
  total: 0,
  itemsPerPage: 10,
}

export const FILE_LIMIT_SIZE_10MB = 10000000

export const ONE_HOUR_IN_MILLISECONDS = 3600000

export const IS_PRODUCTION = env.VITE_APP_ENV_NAME === 'production'

export const PAGE_HEADER_OFFSET = IS_PRODUCTION ? '100px' : '132px'

export const REGEX_PATTERN = {
  ONLY_DIGITS: /^\d*$/,
  NO_DIGITS: /\d/g,
  FULL_NAME: /^[A-Za-zÀ-ÖØ-öø-ÿ]+(?:\s[A-Za-zÀ-ÖØ-öø-ÿ]+)+$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  CELLPHONE_NUMBER: /\(\d{2}\) \d{5}-\d{4}/,
  CPF_TERM: /^(?=.*\d)[\d.\-\s]+$/,
} as const

export const NAME_MIN_LENGTH = 3

export const STALE_TIMES = {
  ONE_MINUTE: 60,
  THIRTY_MINUTES: 30 * 60,
  ONE_HOUR: 60 * 60,
  DAY: 24 * 60 * 60,
} as const

export const environmentMode = () => {
  const modes = {
    production: null,
    staging: 'staging',
    homologation: 'homologation',
    development: 'development',
  }
  return modes[env.VITE_APP_ENV_NAME] ?? 'development'
}
